import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_TENANT_USERS } from "@/domain/tenantUsers";
const useTenantUsersStore = create()(
  persist(
    (set, get) => ({
      users: DEFAULT_TENANT_USERS,
      updateUser: (id, patch) =>
        set((s) => ({
          users: s.users.map((u) => (u.id === id ? { ...u, ...patch } : u)),
        })),
      addUser: (user) => set((s) => ({ users: [...s.users, user] })),
      getUserByEmail: (email) => {
        const normalized = email.toLowerCase();
        const seed = DEFAULT_TENANT_USERS.find(
          (u) => u.email.toLowerCase() === normalized,
        );
        const fromState = get().users.find(
          (u) => u.email.toLowerCase() === normalized,
        );
        if (fromState && seed) {
          return {
            ...seed,
            ...fromState,
            role: seed.role,
            companyIds: seed.companyIds,
            active: fromState.active ?? seed.active,
          };
        }
        return fromState ?? seed;
      },
    }),
    { name: "gps-erp-next-tenant-users" },
  ),
);
function allowedCompaniesForRole(role, userCompanies) {
  if (role === "group_admin") return userCompanies;
  return userCompanies;
}
export { allowedCompaniesForRole, useTenantUsersStore };
